export default __webpack_public_path__ + "static/media/caret-right.d11aa333.svg";